//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { CheckAvailableChats } from '@api/chat.service'

export default {
  props: {
    shop: {
      required: true,
    },
    title: {},
    subject: {},
    classname: {
      type: String,
      default: '',
    },
    canChat: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      chats: {},
    }
  },
  watch: {
    shop: {
      handler() {
        if (this.shop && this.shop.id) {
          this.checkChats()
        }
      },
      immediate: true,
    },
  },
  methods: {
    getChat(id) {
      return this.chats[id] || 'None'
    },
    async checkChats() {
      const { id } = (await CheckAvailableChats.execute({ shop: this.shop.id }))
      this.$set(this.chats, this.shop.id, id)
      this.chats[this.shop.id] = id
    },
  },
}
